<div class="star-rating">
  <ion-icon
    name="star"
    *ngFor="let num of [1, 2, 3, 4, 5]"
    (click)="rate(num)"
    [ngStyle]="{ color: getColor(num) }"
    [ngClass]="{ 'pointer-event': !isClickable }"
  ></ion-icon>
</div>
